import { useState, useEffect } from "react";
import { Backdrop } from "styles/styles.backdrop";
import { useAtom, useGet } from "state/jotai";
import { Box, Stack } from "@mui/material";
import { DEPOSITECALCULATIONS } from "api/api";
import { Icon } from "assets/Icons_";
import styled from "styled-components";
import { _drawer, active_project, vis_deposite } from "state/store.global";
import { useActiveUnit } from "components/Unit";
import { _bootstrap } from "state/store.bootstrap";
import { Container, Inner } from "./HousingBenefit.style";
import { LottiPlay } from "components/LottieAnimation/LottiePlay";

const StyledImage = styled.img`
  width: 637px;
  height: 200px;
  object-fit: cover;
`;

const Row = styled.div`
  padding: 0.4rem 0;
  font-size: 16px;
  font-weight: 400;
  font-family: Arial;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Line = styled.div`
  min-height: 1px;
  max-height: 1px;
  width: 100%;
  background: lightgray;
`;

export const DepositePortal = ({ MIPC, loading, error, close }) => {
  const setDepositePrice = useAtom(vis_deposite)[1];
  const unit = useActiveUnit();

console.log(MIPC,"smssmm")

  const isInvalidValue = (value) =>
    value === null || value === "0" || value === "0,0" || value === "999999" || value === "999.999";

  const imageUrl = unit.getImages()[4]?.url;

  const icon = {
    icon: "close6",
    color: "#fff",
    wrap: { position: "absolute", top: 20, right: 20 },
    size: "20",
    click: close,
  };

  return (
    <>
      <Backdrop onClick={close} />
      <Container>
       
            <StyledImage src={imageUrl} alt="Unit Image" />
            <Icon {...icon} />
            <Inner>
              <h2>Hvad er depositum?</h2>
              <div style={{ display: "flex", paddingBottom: "24px", fontSize: "17px" }}>
                <p>Depositum er udregnet ved husleje x antal måneder i depositum</p>
              </div>
              <Box>
                <div>
                  {!isInvalidValue(MIPC?.rent) && (
                    <>
                      <Row>
                        <div>Husleje</div>
                        <div>{MIPC?.rent} kr.</div>
                      </Row>
                      <Box sx={{ height: 5 }} />
                    </>
                  )}
                  {!isInvalidValue(MIPC?.deposit_number_of_month) && (
                    <>
                      <Line />
                      <Box sx={{ height: 5 }} />
                      <Row>
                        <div style={{ display: "flex", gap: "4px" }}>
                          Antal måneder i depositum
                        </div>
                        <div>{MIPC?.deposit_number_of_month} mdr.</div>
                      </Row>
                    </>
                  )}
                </div>
                <Line />
                <div style={{ height: 10 }} />
                {!isInvalidValue(MIPC?.deposit) && (
                  <Row>
                    <div style={{ fontWeight: "600" }}>Depositum</div>
                    <div style={{ fontWeight: "600" }}>{`${MIPC?.deposit} kr.`}</div>
                  </Row>
                )}
                <Box sx={{ height: 5 }} />
                <Line />
              </Box>
              <Stack direction="row" spacing="1px" justifyContent="center"></Stack>
            </Inner>
         
      </Container>
    </>
  );
};
